"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GraphandField_1 = __importDefault(require("../GraphandField"));
class GraphandFieldJSON extends GraphandField_1.default {
    getter(value, from) {
        var _a;
        if (typeof value !== "object") {
            value = {};
        }
        const res = Object.assign({}, value);
        const _fields = this.fields || {};
        Object.keys(_fields).forEach((key) => {
            const field = _fields[key];
            if (!field) {
                return;
            }
            if (res[key] === undefined) {
                res[key] = field.defaultValue;
            }
            if (field === null || field === void 0 ? void 0 : field.getter) {
                res[key] = field.getter(res[key], from);
            }
        });
        if ((_a = Object.keys(res)) === null || _a === void 0 ? void 0 : _a.length) {
            if (Object.keys(res).every((key) => key == String(parseInt(key)))) {
                return Object.values(res);
            }
        }
        else if (Array.isArray(value)) {
            return value;
        }
        return res;
    }
    setter(value, from) {
        if (typeof value !== "object") {
            value = {};
        }
        const res = Object.assign({}, value);
        const _fields = this.fields || {};
        Object.keys(_fields).forEach((key) => {
            const field = _fields[key];
            if (!field) {
                return;
            }
            if (field === null || field === void 0 ? void 0 : field.setter) {
                res[key] = field.setter(res[key], from);
            }
        });
        return res;
    }
}
GraphandFieldJSON.__fieldType = "JSON";
exports.default = GraphandFieldJSON;
